var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "ifact-form-upload" },
    [
      _c("button", { class: _vm.buttonClass, on: { click: _vm.toggleModal } }, [
        _vm._v(_vm._s(_vm.buttonText))
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: { heading: "Upload the iFacts form for the candidate." }
        },
        [
          _c(
            "form",
            {
              attrs: {
                action:
                  "/recruiter/active-requisitions/upload-ifact-form/" +
                  _vm.jobApplication.id,
                method: "post",
                enctype: "multipart/form-data"
              }
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_csrfToken" },
                domProps: { value: _vm.csrfToken }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "cell shrink" }, [
                  _c("input", {
                    attrs: {
                      type: "file",
                      name: "document_url",
                      id: "file",
                      accept: ".pdf"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c("div", { staticClass: "cell shrink" }, [
                  _vm._v(
                    "\n                    Has this candidate ever been convicted of an offence?\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "select",
                    {
                      staticClass: "form-control",
                      attrs: {
                        name: "is_ever_convicted",
                        id: "is_ever_convicted",
                        required: ""
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(" -Select- ")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "0" } }, [_vm._v("No")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [_vm._v("Yes")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success mycalling-green upload",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("Upload")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button warning",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleModal }
                },
                [_vm._v("Close")]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85bce5a0", { render: render, staticRenderFns: staticRenderFns })
  }
}